import * as React from "react";
import { IconButton, IconButtonProps, Tooltip } from "@mui/material";
import { Restore } from "@mui/icons-material";

export type RestoreIconButtonProps = {
    onClick?: React.MouseEventHandler<HTMLButtonElement>;
    tooltip?: React.ReactNode;
    square?: boolean;
} & Omit<IconButtonProps, "onClick">;

export const RestoreIconButton = React.forwardRef<HTMLButtonElement, RestoreIconButtonProps>(
    ({ onClick, tooltip = "restore", square = false, size = "small", sx, ...rest }, ref) => {
        return (
            <Tooltip title={tooltip}>
                <span>
                    <IconButton
                        ref={ref}
                        onClick={onClick}
                        size={size}
                        sx={{
                            color: "action.active",
                            "&:hover": { color: "warning.main" },
                            ...(square && { borderRadius: 1, px: 1 }),
                            ...sx,
                        }}
                        {...rest}
                    >
                        <Restore fontSize={size === "small" ? "small" : "medium"} />
                    </IconButton>
                </span>
            </Tooltip>
        );
    }
);

RestoreIconButton.displayName = "RestoreIconButton";
